<app-header></app-header>

<div class="container-fluid">
  <ng-content></ng-content>
  <div></div>
</div>
